// External Libs
import React from "react"
import { detect } from "detect-browser"
import { S3_AWS_URL } from "imports/desktopConstants"
import { b64toBlobUrl, generateStaticUrl } from "shared/imports/sharedHelperFunctions"

// Page Styliing
import "app/static/stylus/reusable_components/PDFViewer.styl"

export default class PDFViewer extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasLoaded: false }
    }

    onLoad = (args) => {
        if (!this.state.hasLoaded) {
            this.setState({ hasLoaded: true })
        }
        this.props.onLoadCallback?.(args)
    }

    /*
        get the Url to display in the iFrame.
        If it is a blob URL already, display it.
        If it is a pdf / json from a baseb64Img, take the base64 encoded file and convert it to a Blob url.
        if its an aws pdf, display it on S3.
        if it is some other link, use the google docs viewer
    */
    getUrl = () => {
        if (this.props.blobUrl) {
            return this.props.blobUrl
        }
        if (this.props.baseb64Img) {
            return b64toBlobUrl(this.props.baseb64Img.base64Data, this.props.baseb64Img.mimeType)
        }
        const pdfUrl = this.props.url || ""
        const browser = detect()

        // pdfjs does not support IE. If browser is using IE, use google docs pdf viewer
        return pdfUrl?.includes(S3_AWS_URL) && browser.name !== "ie"
            ? // if the url exists and contains a S3 link, render it,
              // Our PDF viewer has whitelisted S3 and will not function for any other domain
              // https://github.com/QuorumUS/pdf.js
              // encodeURIComponent required due to
              // https://github.com/mozilla/pdf.js/wiki/Frequently-Asked-Questions#can-i-specify-a-different-pdf-in-the-default-viewer
              `https://static.quorum.us/global/js/pdfjs-4.8.69/web/viewer.html?file=${encodeURIComponent(pdfUrl)}#pagemode=none`
            : // else, use the google docs viewer
              `https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true`
    }

    render() {
        const iFrameUrl = this.getUrl()
        const loadingGif = generateStaticUrl("/common/images/loading.gif")
        const dataPlumAttributes = this.props.dataPlumAttributes || {}
        return (
            <div className={this.props.className}>
                <div
                    className={this.state.hasLoaded ? ".pdf-viewer-loading-no-display" : "pdf-viewer-loading"}
                    style={{
                        // Using a gif of the loading logo because we cannot place LoadingSpinner as a background image
                        backgroundImage: `url(${loadingGif})`,
                    }}
                />
                <iframe
                    className="pdf-viewer"
                    src={iFrameUrl}
                    allowFullScreen
                    onLoad={this.onLoad}
                    title="PDF Content"
                    key={iFrameUrl}
                    {...dataPlumAttributes}
                />
            </div>
        )
    }
}
